import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../AccountForm.meta';

export const AnnuityParticipationRate = () => {
  const { control } = useFormContext<FormFields>();

  return (
    <Controller
      control={control}
      name="bankAccount.AnnuityParticipationRate"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          label="Participation Rate"
        />
      )}
    />
  );
};
